
import { Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { DisenioBodega } from "../../layout";
import { FormTransladoBodegas, TarjetasOpciones } from "../../components";
import { ModalFormUno } from "../../components/components/ModalFormUno";
import { useModalesStore } from "../../../store";
import { useNotificacionXBodega } from "../../../hooks";





export const OpcionesBodega = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { changeEstadoModalUno } = useModalesStore(); 
    const { notificacionXBodegaQuery } = useNotificacionXBodega(id);
    const cantidadnoti = notificacionXBodegaQuery?.data?.length; 
    
    
    const handleNavegar = (url) => {
        navigate(`/admin/bodega/${id}/${url}`)
    }



    const data = [
        {key:1, titulo:'Editar Bodega', function: handleNavegar, url:'edit', icono:'setting'},
        {key:2, titulo:'Stock de Bodega', function: handleNavegar, url:'productos', icono:'inventory'},
        {key:5, titulo:'Traslados', function: () => changeEstadoModalUno(true), url:'productos', icono:'traslado'},
        {key:3, titulo:'Historial Movimientos', function: handleNavegar, url:'historial', icono:'historial'},
        {key:4, titulo:'Notificaciones', function: handleNavegar, url:'notificaciones', icono:'notificacion', cantidad:cantidadnoti},
    ];


    return (

        <DisenioBodega titulo="Opciones de Bodega" url={1}>

            <Grid container spacing={3} sx={{mt:1}}>
                {data.map( item => (
                    <Grid key={item.key} item xs={6} sm={4} md={3} lg={2.4}>
                        <TarjetasOpciones
                            onClickHandler={item.function} 
                            url={item.url} 
                            icono={item.icono} 
                            titulo={item.titulo} 
                            cantidad={item.cantidad}
                        />
                    </Grid>
                ))}
            </Grid>


            <ModalFormUno titulo="Traslado de Producto" valor={{}} onClose={() => changeEstadoModalUno(false)}>
                <FormTransladoBodegas />
            </ModalFormUno>
        </DisenioBodega>

    )
}
